import React from 'react';
import { HistoryIcon } from 'lucide-react';
import { StatusPill } from './ui/StatusPill';
import type { DisclosureHistoryEntry } from '../types/disclosures';
import { pluralize } from '../utils/format';
interface DisclosureHistoryProps {
  entries: DisclosureHistoryEntry[];
}
export function DisclosureHistory({
  entries
}: DisclosureHistoryProps) {
  if (entries.length === 0) return null;
  return <section id="disclosure-history" className="rounded-xl border border-slate-200 bg-white" data-id="element-35" data-mp="1h4wgbmvqwacn">
      <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3.5" data-id="element-36" data-mp="1lwmszzi5na78">
        <HistoryIcon className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-37" data-mp="177i7o9g2cpuw" />
        <h2 className="text-[13px] font-semibold text-slate-900" data-id="element-38" data-mp="175duf0w9yehy">Disclosure History</h2>
      </div>
      <ul className="divide-y divide-slate-100" data-id="element-39" data-mp="1c3ywl5v37891">
        {entries.map(entry => <li key={entry.id} className="flex items-start justify-between gap-3 px-5 py-3.5" data-id="element-40" data-mp="y7bw4t3xdzyd">
            <div className="min-w-0" data-id="element-41" data-mp="134ty1zjizewv">
              <div className="flex items-center gap-2" data-id="element-42" data-mp="26tzd96wym703">
                <p className="text-[13.5px] font-medium text-slate-900" data-id="element-43" data-mp="26sfwzgbazvyb">{entry.title}</p>
                <StatusPill tone={entry.status === 'Sent' ? 'success' : 'neutral'} data-id="element-44" data-mp="22s4ea92i45ph">
                  {entry.status}
                </StatusPill>
              </div>
              <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12.5px] text-slate-500" data-id="element-45" data-mp="2bsu9bajxts25">
                <span data-id="element-46" data-mp="1o2zs6gsl5hc3">{entry.sentAt}</span>
                <span aria-hidden="true" className="text-slate-300" data-id="element-47" data-mp="1o1orwqycmrpq">
                  •
                </span>
                <span data-id="element-48" data-mp="1j2tzcxakxosf">{entry.pairLabel}</span>
                <span aria-hidden="true" className="text-slate-300" data-id="element-49" data-mp="1xumdj5yn0wsk">
                  •
                </span>
                <span data-id="element-50" data-mp="1t22rdklvwtc5">{pluralize(entry.documentCount, 'document')}</span>
              </p>
            </div>
            <button type="button" className="shrink-0 rounded-md px-2 py-1 text-[12px] font-medium text-blue-700 transition hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" data-id="element-51" data-mp="15bp8ajla24tp">
              View Details
            </button>
          </li>)}
      </ul>
    </section>;
}